import Header from "./components/header/header";
import Footer from "./components/Footer/footer";
import Biodata from "./components/Biodata";
function App() {
  return (
    <div>
         <Header />
        <Biodata/>
         <Footer />
    </div>
  );
}

export default App;
